import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DataMM07PostureItem } from '../models/DataMM07PostureItem';
import { FormControlUtils } from '../../../../../shared/utils/form-control-utils';
@Component({
    selector: 'cr7-force-case-images',
    templateUrl: './cr7-force-case-images.component.html',
    styleUrls: ['./cr7-force-case-images.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Cr7ForceCaseImagesComponent {
    @Input()
    postureItems: DataMM07PostureItem[] = [];

    @Input()
    isRequired: boolean = true;

    @Input()
    isInvalid: boolean = false;

    @Input()
    isToShowBodyPostureToggle: boolean = false;

    @Input()
    isToShowInputForBodyPosture: boolean = false;

    @Input()
    readOnly: boolean = false;

    @Output()
    bodyPostureClick: EventEmitter<{ defPostureId: number; postureItems: DataMM07PostureItem[] }> = new EventEmitter<{
        defPostureId: number;
        postureItems: DataMM07PostureItem[];
    }>();

    @Output()
    bodyPostureToggleChange: EventEmitter<{ defPostureId: number; value: boolean; postureItems: DataMM07PostureItem[] }> = new EventEmitter<{
        defPostureId: number;
        value: boolean;
        postureItems: DataMM07PostureItem[];
    }>();

    @Output()
    bodyPostureBlur: EventEmitter<DataMM07PostureItem[]> = new EventEmitter<DataMM07PostureItem[]>();

    constructor() {}

    handleBodyPostureClick(defPostureId: number): void {
        if (!this.isToShowInputForBodyPosture) {
            this.postureItems = this.postureItems.map(posture => ({
                ...posture,
                percentage: posture.defPostureId === defPostureId ? 100 : null,
                image: {
                    ...posture.image,
                    isSelected: posture.defPostureId === defPostureId
                }
            }));
            this.bodyPostureClick.emit({ defPostureId, postureItems: this.postureItems });
        }
    }

    handleBodyPostureToggleChange(value: boolean) {
        this.isToShowInputForBodyPosture = value;
        this.postureItems = value ? this.updatePostureItemsForToggleOn() : this.updatePostureItemsForToggleOff();
        this.bodyPostureToggleChange.emit({ defPostureId: this.getMaxPercentagePosture().defPostureId, value: value, postureItems: this.postureItems });
    }

    handleBodyPosturePercentageBlur(percentage: number | null, postureChanged: DataMM07PostureItem) {
        this.postureItems = this.postureItems.map(posture => ({
            ...posture,
            percentage: postureChanged.image.id === posture.image.id ? percentage : posture.percentage,
            image: {
                ...posture.image,
                isSelected: this.shouldSelectImage(posture, postureChanged, percentage)
            }
        }));
        this.bodyPostureBlur.emit(this.postureItems);
    }

    private getMaxPercentagePosture() {
        return this.postureItems.reduce(
            (maxPosture, currentPosture) => (currentPosture.percentage! > maxPosture.percentage! ? currentPosture : maxPosture),
            this.postureItems[0]
        );
    }

    private updatePostureItemsForToggleOn(): DataMM07PostureItem[] {
        return this.postureItems.map(posture => ({
            ...posture,
            percentage: posture.image.isSelected! ? 100 : null,
            image: {
                ...posture.image,
                isSelectable: false,
                isSelected: (posture.percentage !== 0 && posture.percentage !== null) || posture.image.isSelected!
            }
        }));
    }

    private updatePostureItemsForToggleOff(): DataMM07PostureItem[] {
        return this.postureItems.map(posture => ({
            ...posture,
            percentage: null,
            image: {
                ...posture.image,
                isSelectable: true,
                isSelected: false
            }
        }));
    }

    private shouldSelectImage(posture: DataMM07PostureItem, postureChanged: DataMM07PostureItem, percentage: number | null): boolean {
        const isPercentageValid = percentage !== null && percentage !== 0;
        const isSameImage = postureChanged.image.id === posture.image.id;

        if (!isSameImage) {
            return posture.image.isSelected!;
        }

        return isPercentageValid && isSameImage;
    }

    protected readonly FormControlUtils = FormControlUtils;
}
